import React, { useEffect, useState } from 'react';
import ListWrapperComponent from '../../common/components/listWrapper';
import { theme, Text } from '@pfmam/pfmam';
import {GetWireInstructions,GetPhysicalAddress} from '../../actions/actions';

const SendWireModalContent = ({fundDetails, ProgramID}) => {
    const [fundPhysicalAddress, setFundPhysicalAddress] = useState({
      BuildingNumber: '',
      StreetName: '',
      City: '',
      State: '',
      County: '',
      ZipCode: '',
    });
  const [wireInstructions,setWireInstructions] =useState({"mvarABANumber": "",
                                                          "mvarBankAccountNumber": "",
                                                          "mvarBankCity": "",
                                                          "mvarBankName": "",
                                                          "mvarBankState": "",
                                                          "mvarBeneAccountNumber": "",
                                                          "mvarBeneDetails": "",
                                                          "mvarBeneName": "",
                                                          });
  useEffect(() => {
     GetWireInstructions(fundDetails.FundUniqueID) 
        .then((response) => {
          setWireInstructions(response.data)
        })
        .catch((error) => {
          console.log(error);
        });
  }, [fundDetails.FundUniqueID]);


    useEffect(() => {
      GetPhysicalAddress(ProgramID) 
          .then((response) => {
            if (response.data && response.data.Table.length > 0) {
              setFundPhysicalAddress(response.data.Table[0]);
            }
          })
          .catch((error) => {
            console.log(error);
          });
    }, [ProgramID]);
  return (
    <>
      <Text
        label="Send funds using the following wire instructions." 
        color={`${theme.colors.grey_tertiary}`}
        fontSize={`${theme.font_size.size_xl}`}
        margin="0 75px 32px"
      />
      <ListWrapperComponent label="Bank Name" value={wireInstructions.mvarBankName} />
      <ListWrapperComponent
        label="Bank City, State"
        value={wireInstructions.mvarBankCity +', '+ wireInstructions.mvarBankState}
      />
      <ListWrapperComponent label="ABA#" value={wireInstructions.mvarABANumber} />
      <ListWrapperComponent
        label="Credit"
        value={wireInstructions.mvarBeneName}
      />
      <ListWrapperComponent label="Account Number" value={wireInstructions.mvarBankAccountNumber} />
      <ListWrapperComponent
        label="Further Credit"
        value={wireInstructions.mvarBeneDetails +' '+ wireInstructions.mvarBeneAccountNumber }
     />    
       <Text
        label="Fund Physical Address" 
        color={`${theme.colors.grey_tertiary}`}
        fontSize={`${theme.font_size.size_2xl}`}
        margin="32px 150px 32px"
      />
    <ListWrapperComponent label="Building Number" value={fundPhysicalAddress.BuildingNumber} />
      <ListWrapperComponent
        label="Street Name"
        value={fundPhysicalAddress.StreetName}
      />
      <ListWrapperComponent label="City" value={fundPhysicalAddress.City} />
      <ListWrapperComponent
        label="State"
        value={fundPhysicalAddress.State}
      />
      <ListWrapperComponent label="County" value={fundPhysicalAddress.County} />
      <ListWrapperComponent
        label="Zip Code"
        value={fundPhysicalAddress.ZipCode}
     /> 
    </>
  );
};

export default SendWireModalContent;
